export enum GitReferenceType {
  Branch = 'branch',
  Tag = 'tag',
  Hash = 'hash',
}
